import React from "react";
import { useField } from "formik";

export const IconTextInput = ({ label, iconFlip, ...props }) => {
	const [field, meta] = useField(props);
	const icon = `icon: ${props.icon}`;

	return (
		<div className="uk-margin">
			<label className="uk-form-label">{label}</label>
			<div className="uk-inline uk-width-1-1">
				<span
					className={`uk-form-icon ${iconFlip ? "uk-form-icon-flip" : ""}`}
					uk-icon={icon}
				/>
				<input className="uk-input" {...field} {...props} />
			</div>
			{meta.touched && meta.error && (
				<span className="validate-error">{meta.error}</span>
			)}
		</div>
	);
};

export const TextInput = ({ label, helpText, noMargin = false, ...props }) => {
	const [field, meta] = useField(props);

	return (
		<div className={`${noMargin ? "" : "uk-margin"}`}>
			<label className="uk-form-label">
				{label}
				{helpText && (
					<i
						className="help-icon"
						uk-icon="icon: fa-regular-question-circle; ratio: 0.8"
						uk-tooltip={`title: ${helpText}; pos: right`}
					/>
				)}
			</label>
			<div className="uk-form-controls">
				<input className="uk-input" {...field} {...props} />
			</div>
			{meta.touched && meta.error && (
				<span className="validate-error">{meta.error}</span>
			)}
		</div>
	);
};

export const SelectInput = ({
	label,
	data,
	initialEmpty = false,
	handleChange,
	...props
}) => {
	const [{ onChange, ...field }, meta, { setValue, ...helper }] =
		useField(props);
	return (
		<div className="uk-margin">
			{label && <label className="uk-form-label">{label}</label>}
			<div className="uk-form-controls">
				<select
					className="uk-select"
					onChange={(e) => {
						onChange(e);
						if (handleChange) handleChange(e.target.value);
					}}
					{...field}
					{...props}
				>
					{initialEmpty && <option value=""></option>}
					{data.map((item, index) => (
						<option
							key={index}
							value={item.value}
							className="uk-text-capitalize"
						>
							{item.name}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export const CheckboxInput = ({
	label,
	helpText,
	handleChange,
	noMargin = false,
	...props
}) => {
	const [{ onChange, ...field }, meta, { setValue }] = useField(props);
	return (
		<div className={`${noMargin ? "uk-margin-left" : "uk-margin"}`}>
			<label className="uk-form-label">
				<input
					className="uk-checkbox uk-margin-right"
					type="checkbox"
					checked={field.value}
					onChange={() => {
						if (handleChange) handleChange(!field.value);

						// if (acceptType)
						// 	acceptType(
						// 		field.name.split(".")[1],
						// 		field.name.split(".")[2],
						// 		!field.value
						// 	);

						setValue(!field.value);
					}}
					{...field}
					{...props}
				/>
				{label}
			</label>
		</div>
	);
};
